const inputFields = [
  {
    name: "locale_code",
    type: "dynamic_select",
    label: "Select Language",
    placeholder: "",
    options: []
  },
];

export default inputFields;
